module.exports = __webpack_public_path__ + "media/04_tenrai.6a00027c.mp3";